import {
  CheckCircleFilled,
  ClockCircleFilled,
  CloseCircleFilled,
} from "@ant-design/icons";
import type { BillingEntity } from "@shared/lib/types/briefCampains";
import styles from "../styles.module.scss";

type PanStatus = "Valid" | "Invalid" | "Pending";

type PanVerificationBadgeProps = {
  billingEntity: BillingEntity;
};

const resolvePanStatus = (billingEntity: BillingEntity): PanStatus | null => {
  if (!billingEntity.isPan && !billingEntity.panNumber) return null;
  const status = billingEntity.panVerification?.status;
  if (status === "Valid" || status === "Invalid") {
    return status;
  }
  return "Pending";
};

const STATUS_META: Record<
  PanStatus,
  { label: string; className: string; Icon: typeof CheckCircleFilled }
> = {
  Valid: {
    label: "Valid",
    className: styles.panBadgeValid,
    Icon: CheckCircleFilled,
  },
  Invalid: {
    label: "Invalid",
    className: styles.panBadgeInvalid,
    Icon: CloseCircleFilled,
  },
  Pending: {
    label: "Verification Pending",
    className: styles.panBadgePending,
    Icon: ClockCircleFilled,
  },
};

export function PanVerificationBadge({
  billingEntity,
}: PanVerificationBadgeProps) {
  const status = resolvePanStatus(billingEntity);
  if (!status) return null;

  const meta = STATUS_META[status];
  const Icon = meta.Icon;

  return (
    <span
      className={`${styles.panBadge} ${meta.className}`}
      title={`PAN verification: ${meta.label}`}
    >
      {/* <Icon className={styles.panBadgeIcon} /> */}
      <span className={styles.panBadgeLabel}> {meta.label}</span>
    </span>
  );
}
